import React, { useMemo } from 'react';
import Footer from '../../components/Layout/Footer';
import SearchModal from '../../components/Layout/Header/SearchModal';
import SiteBreadcrumb from '../../components/Common/Breadcumb';
import DetailsHeader from '../../components/Layout/Header/DetailsHeader';
import SectionTitle from '../../components/Common/SectionTitle';
import ServiceDetailsContent from './ServiceDetailsContent';

import ServiceIt from '../sections/ServiceIt';
import Brand from '../../components/Common/Brand';
import ScrollToTop from '../../components/Common/ScrollTop';
import OnepageContactPart from '../../components/Contact/OnepageContact';

// Breadcrumbs Image
import breadcrumbsImg from '../../assets/img/breadcrumbs/2.jpg';
import serviceImg from '../../assets/img/service/4.png';

const ITSoftware = () => {
    const content = useMemo(() => {
        return (
            <SectionTitle
                sectionClass="sec-title4"
                descClass="desc desc-big"
                description="Bizu LLC provides disciplined IT and software services designed to strengthen operational resilience, modernize business processes, and support long-term organizational growth. Our approach combines technical depth, structured delivery, and client-focused governance to ensure that each engagement aligns with mission priorities, security expectations, and measurable business outcomes."
                secondDescClass="desc"
                secondDescription={
                    <div>
                        <p>
                            We support clients across the full technology lifecycle, from advisory planning and architecture through implementation, integration, enhancement, and ongoing support. Whether the requirement involves custom software delivery, enterprise platform modernization, cloud enablement, data-driven reporting, or systems interoperability, our team emphasizes clarity of scope, disciplined execution, and solutions that are maintainable over time.
                        </p>
                        <p>
                            Our IT and software practice is built to help organizations reduce friction in day-to-day operations while improving visibility, scalability, and service quality. We work collaboratively with stakeholders to define requirements, mitigate delivery risk, and implement solutions that are practical, secure, and aligned with real operational needs rather than one-size-fits-all technology choices.
                        </p>
                    </div>
                }
            />
        );
    }, []);

    return (
        <React.Fragment>
            <DetailsHeader parentMenu='service' secondParentMenu='services' activeMenu='/service/it-software' />
            <SiteBreadcrumb breadcrumbsImg={breadcrumbsImg} pageTitle='IT & Software' pageCategory='Services' pageName='IT & Software' parentPath="/service" />

            <ServiceDetailsContent
                title="Enterprise IT and software services aligned to operational and strategic objectives"
                subtitle="IT & Software"
                children={content}
                serviceImg={serviceImg}
            />

            <ServiceIt />
            <OnepageContactPart contactSectionClass="rs-contact gray-bg pt-120 md-pt-80" />
            <Brand />
            <ScrollToTop />

            <Footer />
            <SearchModal />
        </React.Fragment>
    );
}

export default ITSoftware;
